import { BreakpointObserver } from '@angular/cdk/layout';
import { Component } from '@angular/core';
import { AuthenticationService } from 'src/app/_services';
import { MaterialPage } from '../../../../components/page/material-page.component';
import { WebViewService } from 'src/app/_services/webview.service';
import { Meta, Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { SidenavService } from 'src/app/_services/sidenav.service';

@Component({
  selector: 'signup-page',
  templateUrl: './signup-page.component.html',
  styleUrls: ['./signup-page.component.scss']
})
export class SignupPageComponent extends MaterialPage {

  assetsBaseURL = environment.assetsBaseURL;

  constructor(
    private authenticationServcie: AuthenticationService,
    breakpointObserver: BreakpointObserver,
    private webViewService: WebViewService,
    titleService: Title,
    meta: Meta,
    private router: Router,
    sidenavService: SidenavService
  ) {
    super(
      breakpointObserver, 
      titleService, 
      meta, 
      sidenavService,
      router,
      $localize `:page title:Sign up`, 
      $localize `:page description:Turn your unused things into cash. Effortlessly.`,
      true);
  }
  
  login() {
    if (!this.webViewService.detectWebView()) {
      this.authenticationServcie.login("/access-inbox");
    }
  }
  
  toAccessInbox() {
    this.router.navigate(['access-inbox']);
  }
  
  get isLoggedIn() {
    return this.authenticationServcie.isAuthenticated();
  }
}
